import SiteLayout from '@/components/feature/SiteLayout';
import PageHero from '@/components/feature/PageHero';
import CtaBanner from '@/components/feature/CtaBanner';
import ContactChannels from '@/pages/contact/components/ContactChannels';
import ContactFaq from '@/pages/contact/components/ContactFaq';
import InquiryForm from '@/pages/contact/components/InquiryForm';
import { departments } from '@/mocks/contactData';
import { brandInfo, socialLinks } from '@/mocks/homeData';

export default function ContactPage() {
  return (
    <SiteLayout>
      <PageHero
        eyebrow="Contact Us"
        title="Let's Talk About Your Ayurvedic Requirements"
        description="Manufacturer-direct pricing, bulk supply, distributorship or product questions — reach out and our team will get back to you within one business day."
        crumbs={[{ label: 'Home', to: '/' }, { label: 'Contact' }]}
      />

      <ContactChannels />

      <section id="enquiry" className="w-full bg-background-100 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10">
            <div className="flex flex-col gap-5">
              <div className="rounded-lg overflow-hidden border border-background-200 bg-background-50">
                <iframe
                  title="Best Research Pharma location on Google Maps"
                  aria-label="Best Research Pharma location map"
                  src={brandInfo.mapEmbed}
                  className="w-full h-[300px] md:h-[360px]"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              <div className="rounded-lg border border-background-200 bg-background-50 p-6">
                <h2 className="font-heading text-lg font-semibold text-foreground-950">Our Departments</h2>
                <p className="mt-1 text-sm text-foreground-600">Reach the right team directly.</p>
                <div className="mt-5 space-y-4">
                  {departments.map((dept) => (
                    <div key={dept.id} className="flex items-start gap-4">
                      <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 shrink-0">
                        <i className={`${dept.icon} text-lg`}></i>
                      </span>
                      <div className="flex-1">
                        <h3 className="text-sm font-semibold text-foreground-950">{dept.title}</h3>
                        <p className="mt-0.5 text-xs text-foreground-600">{dept.description}</p>
                        <div className="mt-1.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs">
                          <a
                            href={`tel:${dept.phone.replace(/\s/g, '')}`}
                            className="inline-flex items-center gap-1.5 text-primary-700 hover:text-primary-600 transition-colors cursor-pointer"
                          >
                            <i className="ri-phone-line"></i>
                            {dept.phone}
                          </a>
                          <a
                            href={`mailto:${dept.email}`}
                            className="inline-flex items-center gap-1.5 text-primary-700 hover:text-primary-600 transition-colors cursor-pointer break-all"
                          >
                            <i className="ri-mail-line"></i>
                            {dept.email}
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-6 pt-5 border-t border-background-200 flex items-center gap-2">
                  <span className="text-xs font-semibold text-foreground-700 mr-1">Follow Us:</span>
                  {socialLinks.map((item) => (
                    <a
                      key={item.id}
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={item.label}
                      title={item.label}
                      className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      <i className={`${item.icon} text-base`}></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <InquiryForm />
          </div>
        </div>
      </section>

      <ContactFaq />

      <CtaBanner
        eyebrow="Grow With Us"
        title="Become a Distributor of Best Research Pharma"
        description="Join 300+ distributors across 18+ states and offer your market authentic, GMP-certified Ayurvedic medicines with attractive margins."
        primary={{ label: 'Apply for Distributorship', to: '/#distributor-apply', icon: 'ri-hand-heart-line' }}
        secondary={{ label: 'Explore Products', to: '/products', icon: 'ri-shopping-bag-3-line' }}
      />
    </SiteLayout>
  );
}